import { Component, Input, OnInit } from '@angular/core';
import { FolderIconComponent } from "../folder-icon/folder-icon.component";
import { FolderInfo } from '../../../../core/interfaces/folder-info';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-folder-button',
  standalone: true,
  imports: [FolderIconComponent, CommonModule, TranslocoPipe],
  templateUrl: './folder-button.component.html',
  styleUrl: './folder-button.component.css'
})
export class FolderButtonComponent implements OnInit {
  @Input() folderInfo: FolderInfo | null = null;
  @Input() isSelected: boolean = false;

  ngOnInit(): void {
    if (this.folderInfo) {
      this.folderInfo!.folderColor ??= "#A9BE92";
      this.folderInfo!.folderBackgroundColor ??= "#D9E5E4";
    }
  }
}
